/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_COLOR,
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS, mobileTariffs } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      INCORRECT_PARAMS: {
        errorInfo: {
          buttons: mobileTariffs.showListButton,
        },
      },
      PRODUCT_REGISTERED: {
        errorInfo: {
          buttons: mobileTariffs.showListButton,
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorInfo: {
          title: 'Lo sentimos, no podemos ofrecerte esta tarifa',
          msg: [
            'Actualmente no puedes contratar líneas adicionales.',
            'Consulta las tarifas de contrato que tenemos disponibles para ti.',
          ],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Ver tarifas móviles',
            link: URLS.MOBILE_TARIFF_LIST,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
        },
      },
      INCOMPATIBLE_PRODUCT_CONTRATO_L: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Ver líneas adicionales',
            link: URLS.MOBILE_TARIFF_LME_LIST,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          title: 'Aprovecha el precio exclusivo de línea adicional',
          msg: [
            'Ya tienes una línea móvil de contrato.',
            'Contrata esta tarifa como línea adicional a un precio exclusivo.',
          ],
          errorName: 'producto incompatible contrato L',
        },
      },
      NOT_ACTIVATABLE_LINES: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Volver a mis productos',
            link: URLS.MY_PRODUCTS,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          title: 'No es posible generar tu pedido',
          msg: [
            'Tras revisar tu configuración te informamos que no tienes líneas móviles pendientes de activación.',
          ],
          errorName: 'sin lineas incluidas activables',
        },
      },
      INCORRECT_BISI_CHARS: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [{
            label: 'Llama gratis al 900106235',
            link: 'tel:900106235',
            forceExternal: true,    
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
            color: BUTTON_COLOR.BLUE,
          }],
          title: 'No disponemos de los datos del representante legal.',
          msg: [
            'Puedes llamar gratis al 900106235 y un asesor comercial te ayudará a completar tu pedido. Sentimos las molestias.',
          ],
          errorName: 'error bisi chars',
        },
      },
      DEFAULT_ERROR: {
        errorInfo: {
          buttons: mobileTariffs.showListButton,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
    selfEmployed: {
      INCOMPATIBLE_PRODUCT_CONTRATO_L: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Ver oferta',
            link: URLS.SELF_EMPLOYED_MOBILE_TARIFF_LME_LIST,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.MEDIUM,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          title: 'Por ser cliente, tenemos una tarifa a precio especial con datos ilimitados.',
          msg: [
            'Actualmente no podemos ofrecerte la tarifa que has seleccionado, consulta la oferta que tenemos para ti.',
          ],
          errorName: 'producto incompatible contrato L - autonomo',
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorInfo: {
          title: 'Lo sentimos, no podemos ofrecerte esta tarifa',
          msg: [
            'Actualmente no puedes contratar líneas adicionales.',
            'Consulta las tarifas de contrato que tenemos disponibles para ti.',
          ],
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Ver tarifas móviles',
            link: URLS.SELF_EMPLOYED_MOBILE_TARIFF_LIST,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
        },
      }
    },
  }
};
